<script>
	import { getContext } from "svelte";

	const { data, custom } = getContext("LayerCake");

	export let colorNodes;
	export let colorLinks;
	export let link;

	let linkHighlight = $custom.linkHighlight;
	let nodeHighlight = $custom.nodeHighlight;
	let highlightExists = $custom.highlightExists;
	let getLinkId = $custom.getLinkId;

	let handleLinkHover = $custom.handleLinkHover;
	let handleNodeHover = $custom.handleNodeHover;
	let resetHover = $custom.resetHover;
</script>

<defs>
	{#if colorLinks === "gradient"}
		{#each $data.links as link}
			<linearGradient
				id="gradient__{link.source.id}_{link.target.id}"
				gradientUnits="userSpaceOnUse"
				x1={$custom.nodeWidth}
				x2={100 - $custom.nodeWidth}
				y1="0"
				y2="0"
			>
				<stop class="stop1" offset="0%" stop-color={colorNodes(link.source)} />
				<stop class="stop2" offset="100%" stop-color={colorNodes(link.target)} />
			</linearGradient>
		{/each}
	{/if}
</defs>
<g class="sankey-layer">
	<g class="link-group">
		{#each $data.links as d}
			{@const gradientId = "url(#gradient__" + d.source.id + "_" + d.target.id + ")"}
			<path
				d={link(d)}
				on:mouseenter={handleLinkHover(d)}
				on:mouseleave={resetHover}
				fill="none"
				stroke={colorLinks === "gradient" ? gradientId : colorLinks(d)}
				stroke-opacity={$linkHighlight.includes(getLinkId(d)) ? 0.7 : 0.3}
				stroke-width={d.width}
				id="link__{d.source.id}_{d.target.id}"
			/>
		{/each}
	</g>
	<g class="rect-group">
		{#each $data.nodes as d, i}
			{#if d.value}
				<!-- <rect
					x={d.x0}
					y={d.y0}
					height={d.y1 - d.y0}
					width={d.x1 - d.x0}
					fill={colorNodes(d)}
					id="node__{d.id}"
					class:highlighted={$nodeHighlight.includes(d.id)}
					on:mouseover={handleNodeHover(d)}
					on:mouseleave={resetHover}
				/> -->
				<!-- this is a version that simulated an outline instead of the stroke centered around the border -> not sure if we should use it -->
				{@const isHighlighted = $nodeHighlight.includes(d.id)}
				{@const strokeWidth = isHighlighted ? 1 : 0}
				<rect
					x={d.x0 - strokeWidth / 2}
					y={d.y0 - strokeWidth / 2}
					height={d.y1 - d.y0 + strokeWidth}
					width={d.x1 - d.x0 + strokeWidth}
					fill={colorNodes(d)}
					stroke-width={strokeWidth}
					opacity={$highlightExists && !isHighlighted ? 0.7 : 1}
					id="node__{d.id}"
					class:highlighted={$nodeHighlight.includes(d.id)}
					on:mouseover={() => handleNodeHover(d)}
					on:mouseleave={resetHover}
					vector-effect="non-scaling-stroke"
				/>
			{/if}
		{/each}
	</g>
</g>

<style lang="scss">
	path {
		vector-effect: none !important;
		transition: stroke-opacity 0.1s ease-in-out;
	}

	rect {
		stroke: $white;
		stroke-width: 0;
		transition:
			opacity 0.1s ease-in-out,
			x 0.1s ease-in-out,
			y 0.1s ease-in-out,
			height 0.1s ease-in-out,
			width 0.1s ease-in-out,
			stroke-width 0.1s ease-in-out,
			filter 0.1s ease-in-out;

		&.highlighted {
			filter: drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.25));
			stroke-width: 2;
		}
	}
</style>
